<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="fixed inset-0 z-50 flex items-start justify-center sm:items-center"
    >
      <div
        class="fixed inset-0 bg-black/50"
        @click="onOpenChange?.(false)"
      />
      <div
        class="relative mt-8 w-full max-w-lg bg-background shadow-lg sm:mt-0 rounded-lg border"
        :class="props.class"
      >
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
interface Props {
  open?: boolean
  class?: string
}

interface Emits {
  (e: 'update:open', value: boolean): void
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
})

const emit = defineEmits<Emits>()

const onOpenChange = (value: boolean) => {
  emit('update:open', value)
}
</script>
